<template>
  <div class="OrderDetails"  style=" padding:20px;
      background: #ffffff;
      box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
      border-radius: 10px;
    ">
    <p class="comeback" @click="comeback()">
      <span class="el-icon-arrow-left"></span>
      <span>返回</span>
    </p>
    <div class="RequestInfo divbox" style="    margin: 3px 29px;">
      <h4>委托信息</h4>
      <ul class="RI_ul">
        <li>
          <p>
            <span style="">运单号 </span><span>{{ routes.nos || "-" }}</span>
          </p>
          <p>
            <span>目的仓库</span
            ><span>
              {{ Alldata.waybilldetails.pod_country || "-" }}
            </span>
          </p>
        </li>
        <li>
          <p>
            <span style="">运输方式 </span
            ><span>{{ Alldata.waybilldetails.transportway || "-" }}</span>
          </p>
          <p>
            <span>委托日期</span
            ><span>
              {{ Alldata.waybilldetails.inputtime || "-" }}
            </span>
          </p>
        </li>
        <li>
          <p>
            <span style="">起运地 </span
            ><span>
              {{ Alldata.waybilldetails.warehouse || "-" }}
              </span>
          </p>
          <p>
            <span>入仓日期</span
            ><span>
              {{ Alldata.waybilldetails.inwarehousetime || "-" }}
            </span>
          </p>
        </li>
      </ul>
    </div>
    <!-- jack start -->
    <div class="jackCard" style="padding: 20px">
      <div style="display: flex; align-items: center">
        <img style="" src="./../../../assets/receiveIcon.png" alt="" />
        <span style="margin-left: 10px; font-size: 20px; font-weight: 550"
          >收货信息</span
        >
      </div>
      <div
        style="
          margin: 20px 30px 5px;
          padding: 0 10px;
          height: 40px;
          border: 1px solid #5f4aff;
          background: rgb(235 232 251);
        "
      >
        <span style="font-size: 18px; line-height: 40px; font-weight: 600">
          {{ Alldata.deswarehouse && Alldata.deswarehouse.warehouse || "暂无收货信息" }}
        </span>
        <span style="line-height: 40px">
           {{ Alldata.deswarehouse &&  Alldata.deswarehouse.tel || "" }}
          {{ Alldata.deswarehouse &&  Alldata.deswarehouse.province || "" }}
          {{ Alldata.deswarehouse &&  Alldata.deswarehouse.city || "" }}
          {{ Alldata.deswarehouse &&  Alldata.deswarehouse.area || "" }}
          {{ Alldata.deswarehouse &&  Alldata.deswarehouse.address || "" }}
        </span>
      </div>
    </div>
    <!-- 请将货物送至以下仓库 -->
    <div v-if="!Alldata.message.isgetgoodstodoor"
      class="jackCard"
      style="
        overflow: hidden;
        margin: 20px 0 20px 30px;
        background: rgb(253 246 217);
      "
    >
      <div style="padding: 10px 30px">
        <span
          style="
            font-size: 26rpx;
            font-family: PingFang SC;
            font-weight: 500;
            color: #c19822;
            line-height: 40rpx;
          "
          >请将货物送至以下仓库</span
        >
      </div>
      <div style="background: #fff; padding: 15px 30px">
        <span
          style="font-size: 16px;
                                font-family: PingFang SC; 
                                font-weight:550
                                line-height: 40px;"
        >
          {{ Alldata.depwarehouse.warehouse || ""  }}
         
        </span>
       
         {{ Alldata.depwarehouse.tel || "" }}
        {{ Alldata.depwarehouse.province || "" }}
        {{ Alldata.depwarehouse.city || "" }}
        {{ Alldata.depwarehouse.area || "" }}
        {{ Alldata.depwarehouse.address || "" }}
      </div>
    </div>
<!-- 请将货物送至以下仓库end -->
<!-- 提货信息 -->
     <div v-if="Alldata.message.isgetgoodstodoor"
      class="jackCard"
      style="
        overflow: hidden;
        margin: 20px 0 20px 30px;
        background: rgb(253 246 217);
      "
    >
      <div style="padding: 10px 30px">
        <span
          style="
            font-size: 26rpx;
            font-family: PingFang SC;
            font-weight: 500;
            color: #c19822;
            line-height: 40rpx;
          "
          >提货信息</span
        >
      </div>
      <div style="background: #fff; padding: 15px 30px">
        <span
          style="font-size: 16px;
                                font-family: PingFang SC; 
                                font-weight:550
                                line-height: 40px;"
        >
          {{ Alldata.message.getgoodsname || "" }}
        </span>
        <span style="margin: 0 10px">
          {{ Alldata.message.getgoodstel || "" }}
        </span>
        
        {{ Alldata.message.getgoodsprovince || "" }}
        {{ Alldata.message.getgoodscity || "" }}
        {{ Alldata.message.getgoodsarea || "" }}
        {{ Alldata.message.getgoodsaddress || "" }}
      </div>
    </div>
   <!-- 提货信息end -->
    <!-- jack end  -->
    <div class="jackCard" style="padding: 30px">
      <div>
        <span
          @click="changeAc(1)"
          style="cursor: pointer; margin-right: 5px"
          :class="{ jackTextAc: acIndex == 1, jackText: acIndex == 2 }"
          >商品预报信息</span
        >
        <span v-if="state == 2"
          @click="changeAc(2)"
          style="cursor: pointer"
          :class="{ jackTextAc: acIndex == 2, jackText: acIndex == 1 }"
          >商品入仓信息</span
        >
      </div>
      <div style="margin: 20px 0" v-if="acIndex == 1">
        <el-table
          border
          :data="Alldata.cargobefore"
          tooltip-effect="dark"
          :header-cell-style="{ background: '#F3F3F3' }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="75px"
            min-width="8%"
          ></el-table-column>
          <el-table-column prop="boxNo" label="箱号">
            <template slot-scope="scope">
                {{scope.row.boxNo || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="poTrackingNo" label="货件追踪号">
             <template slot-scope="scope">
                {{scope.row.poTrackingNo || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="goodstype" label="货物类型">
             <template slot-scope="scope">
                {{scope.row.goodstype || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="weight" label="重量(kgs)">
             <template slot-scope="scope">
                {{scope.row.weight || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="cbm" label="体积(cbm)">
             <template slot-scope="scope">
                {{scope.row.cbm || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="pcs" label="SKU数">
             <template slot-scope="scope">
                {{scope.row.pcs || "-"}}
            </template>
          </el-table-column>
          <el-table-column min-width="100px" prop="piece" label="操作">
            <template  slot-scope="scope">
              <span
                @click="getBoxDetail(scope.row.goodsList)"
                style="color: #5f4aff; cursor: pointer"
                >查看详情</span>
              <span
                @click="toBoxTracking(scope.row.id)"
                style="color: #5f4aff; cursor: pointer"
                >查看轨迹</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin: 20px 0" v-else>
        <div class="tablebox">
           <el-table
          border
          :data="Alldata.cargo"
          tooltip-effect="dark"
          :header-cell-style="{ background: '#F3F3F3' }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="75px"
            min-width="8%"
          ></el-table-column>
          <el-table-column prop="boxNo" label="箱号">
            <template slot-scope="scope">
                {{scope.row.boxNo || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="poTrackingNo" label="PO号">
             <template slot-scope="scope">
                {{scope.row.poTrackingNo || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="goodstype" label="货物类型">
             <template slot-scope="scope">
                {{scope.row.goodstype || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="weight" label="重量(kgs)">
             <template slot-scope="scope">
                {{scope.row.weight || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="cbm" label="体积(cbm)">
             <template slot-scope="scope">
                {{scope.row.cbm || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="pcs" label="SKU数">
             <template slot-scope="scope">
                {{scope.row.pcs || "-"}}
            </template>
          </el-table-column>
          <el-table-column min-width="100px" prop="piece" label="操作">
            <template  slot-scope="scope">
              <span
                @click="getBoxDetail(scope.row.goodsList)"
                style="color: #5f4aff; cursor: pointer"
                >查看详情</span
              >
              <span
                @click="toBoxTracking(scope.row.id)"
                style="color: #5f4aff; cursor: pointer"
                >查看轨迹</span
              >
            </template>
          </el-table-column>
        </el-table>
        </div>
      </div>
    </div>
    <div class="Information divbox" style="    margin: 3px 29px;">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="费用信息" name="second">
          <el-table
            border
            :data="tableData1"
            tooltip-effect="dark"
            :header-cell-style="{ background: '#F3F3F3' }"
            ref="multipleTable"
            style="width: 77%; margin-left: 25px; border-bottom: none"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="index"
              label="序号"
              width="75px"
              min-width="8%"
            >
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.feeitem !== '合计' &&
                    scope.row.feeitem !== '折合人民币'
                  "
                  >{{ parseInt(scope.$index + 1) }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="feeitem"
              label="费用项"
              min-width="8%"
            ></el-table-column>
            <el-table-column
              prop="amountBefore"
              label="预估费用"
              min-width="8%"
            ></el-table-column>
            <el-table-column
              prop="amount"
              label="实际费用"
              min-width="8%"
            ></el-table-column>
          </el-table>
          <el-table
            border
            :data="twotableData"
            style="
              width: 77%;
              margin-left: 25px;
              border-top: none;
              margin-top: 0px;
            "
            :cell-style="{ padding: '5px 0px' }"
            :show-header="false"
          >
            <el-table-column type="index" label="" width="75px" min-width="8%">
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.feeitem !== '合计' &&
                    scope.row.feeitem !== '折合人民币'
                  "
                  >{{ parseInt(scope.$index + 1) }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="feeitem"
              label=""
              min-width="8%"
            ></el-table-column>
            <el-table-column
              prop="amountBefore"
              label=""
              min-width="8%"
            ></el-table-column>
            <el-table-column
              prop="amount"
              label=""
              min-width="8%"
            ></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="轨迹信息" name="third">
          <p
            v-if="!activitieList.length"
            style="text-align: center; padding-top: 50px; font-size: 16px"
          >
            暂无轨迹信息
          </p>
          <el-timeline class="jackContent" v-else>
            <el-timeline-item
              type="primary"
              v-for="(activity, index) in activitieList"
              :key="index"
              :icon="activity.icon"
              :color="index == 0 ? '' : '#999999'"
              :timestamp="`${activity.occurrenceDate} ${activity.occurrenceTime}`"
            >
              {{ activity.name }}
              <span style="color: #999999; margin-top: 6px">{{
                activity.desc ? activity.desc : "暂无"
              }}</span>
              <!-- <span
                style="color: #09bb07; cursor: pointer"
                v-if="activity.detailLinkType == 1"
                @click="getBoxInfo(activity.apptWarehouseOrderId)"
                >查看箱信息</span
              > -->
              <span
                style="color: #09bb07; cursor: pointer"
                v-if="activity.detailLinkType == 2"
                @click="getPics(activity.apptWarehouseOrderId)"
                >查看回执</span
              >
            </el-timeline-item>
          </el-timeline>
        </el-tab-pane>
        <el-tab-pane label="下载标签" name="download">
           <el-button @click="downLoadLabel()" type="success" size="mini" style="margin:10px">点击下载标签</el-button>
        </el-tab-pane>
        
      </el-tabs>
    </div>


    <el-dialog
      center
      class="jackRadius"
      :before-close="beforeClose"
      :visible.sync="showDialog"
      :title="showPic ? '相关回执' : '箱子轨迹'"
      width="60%"
    >
      <div v-if="this.showDialog && this.showPic">
        <el-image
          v-for="(item, index) in urls"
          :key="index"
          style="
            width: 45%;
            height: 45%;
            border-radius: 20px;
            margin: 10px;
            box-shadow: 0px 0px 55px 2px rgba(6, 2, 3, 0.1);
          "
          :src="item"
          :preview-src-list="urls"
        >
        </el-image>
      </div>
      <div v-if="this.showDialog && this.showBox">
        <el-timeline class="jackContent">
          <el-timeline-item
            type="primary"
            v-for="(activity, index) in boxDatailList"
            :key="index"
            :icon="activity.icon"
            :color="index == 0 ? '' : '#999999'"
            :timestamp="`${activity.occurrenceDate} ${activity.occurrenceTime}`"
          >
            {{ activity.name }}
            <span style="color: #999999; margin-top: 6px">{{
              activity.desc ? activity.desc : "暂无"
            }}</span>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-dialog>


    <!-- 查看箱子详情弹窗 -->
     <el-dialog
      center
      class="jackRadius"
      :visible.sync="showGoodsList"
      title="箱子详情"
      width="80%"
      
    >
      <div>
           <el-table
          border  size="mini"
          :data="goodsList"
          tooltip-effect="dark"
          :header-cell-style="{ background: 'rgb(95 74 255 / 23%)' }"
          ref=""
         
          @selection-change="handleSelectionChange"
        >
          <!-- <el-table-column
            type="index"
            label="序号"
            width="75px"
            min-width="8%" -->
          ></el-table-column>
          <el-table-column prop="boxNo" label="中文品名">
            <template slot-scope="scope">
                {{scope.row.namec || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="poTrackingNo" label="英文品名">
             <template slot-scope="scope">
                {{scope.row.namee || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="goodstype" label="品牌">
             <template slot-scope="scope">
                {{scope.row.brand || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="weight" label="SKU">
             <template slot-scope="scope">
                {{scope.row.sku || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="cbm" label="海关编码">
             <template slot-scope="scope">
                {{scope.row.hsCode || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="pcs" label="货值">
             <template slot-scope="scope">
                {{scope.row.price || "-"}}
            </template>
          </el-table-column>
           <el-table-column prop="pcs" label="中文材质">
             <template slot-scope="scope">
                {{scope.row.materialc || "-"}}
            </template>
          </el-table-column>
           <el-table-column prop="pcs" label="英文材质">
             <template slot-scope="scope">
                {{scope.row.materiale || "-"}}
            </template>
          </el-table-column>
           <el-table-column prop="pcs" label="中文用途">
             <template slot-scope="scope">
                {{scope.row.purposec || "-"}}
            </template>
          </el-table-column>
           <el-table-column prop="pcs" label="英文用途">
             <template slot-scope="scope">
                {{scope.row.purposee || "-"}}
            </template>
          </el-table-column>
           <el-table-column prop="pcs" label="商品图片">
             <template slot-scope="scope">
                {{scope.row.pcs || "-"}}
            </template>
          </el-table-column>
         
        </el-table>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "OrderDetails",
  data() {
    return {
      state: 0,
      showGoodsList: false,
      goodsList: [],
      boxDatailList: [],
      acIndex: 1,
      boxInfo: [],
      urls: [],
      showDialog: false,
      showPic: false,
      showBox: false,
      orderNo: "FAAE202012190129A",
      activitieList: [],
      // jack
      tableData_C1: [
        {
          goodname: "衣服",
          weight: "50",
          cbm: "3",
          piece: "200",
        },
      ],
      tableData_C2: [
        {
          goodname: "衣服",
          weight: "50",
          cbm: "3",
          piece: "200",
        },
      ],
      tableData1: [
        {
          feeitem: "海运费",
          amountBefore: "CNY 50",
          amount: "CNY 30",
        },
      ],
      twotableData: [
        {
          feeitem: "合计",
          amountBefore: "CNY 50",
          amount: "CNY 30",
        },
        {
          feeitem: "合计",
          amountBefore: "CNY 50",
          amount: "CNY 30",
        },
      ],
      Alldata: {
        cargobefore: [{}],
        combincostinfo: {
          amount: "",
          amountBefore: "",
          combinCostinfoList: [
            {
              amount: "",
              amountBefore: "",
              feecode: "",
              feeitem: "",
            },
          ],
          totalCost: "",
          totalCostBefore: "",
        },
        costbeforeinfo: {
          amount1: "",
          feeitemBeforeList: [
            {
              amountBefore: "",
              cnyamountBefore: "",
              cnycurrencyBefore: "",
              currencyBefore: "",
              feecode: "",
              feeitemBefore: "",
              piece: "",
              price: "",
            },
          ],
        },
        costinfo: {
          amount2: "",
          feeitemList: [
            {
              amount: "",
              cnyamount: "",
              cnycurrency: "",
              currency: "",
              feecode: "",
              feeitem: "",
              piece: "",
              price: "",
            },
          ],
        },
        depwarehouse: {
          address: "",
          area: "",
          city: "",
          province: "",
          tel: "",
          warehouse: "",
        },
        deswarehouse: {
          address: "",
          area: "",
          city: "",
          province: "",
          tel: "",
          warehouse: "",
        },
        message: {
          cneename: "",
          getgoodsaddress: "",
          getgoodsarea: "",
          getgoodscity: "",
          getgoodsname: "",
          getgoodsprovince: "",
          getgoodstel: "",
          goodstype: "",
          id: "",
          inputtime: "",
          inwarehoustime: "",
          ischangeaddress: true,
          isgetgoodstodoor: true,
          issendgoodstodoor: true,
          pod_country: "",
          pod_country_area: "",
          rece_address: "",
          rece_city: "",
          rece_country: "",
          rece_tel: "",
          shipper_name: "",
          shipper_tel: "",
        },
        schedule: {
          ata: "",
          atd: "",
          cls: "",
          eta: "",
          etd: "",
          pod: "",
          pol: "",
          route: "",
          shippingcompany: "",
          vessel: "",
          voyage: "",
        },
        settleinfo: {
          fkcode: "",
          fkstate: "",
          nopaid: "",
          paid: "",
          paymethod: "",
        },
        state: {
          dealdata: "",
          location: "",
        },
        waybilldetails: {
          abbr: "",
          createway: "",
          cusNos: "",
          inputtime: "",
          inwarehousetime: "",
          jobid: "",
          namec: "",
          nos: "",
          pod_country: "",
          product: "",
          remark: "",
          transportway: "",
          warehouse: "",
        },
      },
      routes: {},
      activeName: "second",
      reverse: false,

      guiji: false,
    };
  },
  watch: {},
  methods: {
    // 下载标签
    downLoadLabel(){
      
      this.axios.get(`/busFbx/downFBXOrderLabel/${this.routes.nos}`)
      .then((res) => {
       if (res.data.code == 200) { 
         console.log();
           let a = document.createElement('a');
              a.setAttribute("href",res.data.data);
              a.setAttribute("target",'_blank');
              a.click();
      } else {
       this.$message.info(res.data.message);
       } 
      }) .catch((res) => {
      console.log(res);
      });
      
    },
    changeAc(index) {
      this.acIndex = index;
    },
    beforeClose() {
      this.showPic = false;
      this.showBox = false;
      this.showDialog = false;
    },
    getBoxDetail(goodsList) {
      this.goodsList = goodsList;
      this.showGoodsList = true;
      // console.log(goodsList);
    },
    toBoxTracking(id) {
      // console.log(id);
      this.axios
        .post(
          `fbxTrail/findBoxTrail`,
          qs.stringify({
            orderNo: this.routes.nos,
            boxId: id,
          })
        )
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.datas.length) {
              console.log(2);
              this.boxDatailList = res.data.datas;
              this.showDialog = true;
              this.showBox = true;
            } else {
              this.$message("没有相关信息");
            }
          } else {
            this.$message("获取失败");
          }
        })
        .catch((res) => {});
    },
    getBoxInfo() {
      //   let id = "";
      //   this.activitieList.length &&
      //     this.activitieList.forEach((item) => {
      //       if (item.apptWarehouseOrderId) {
      //         id = item.apptWarehouseOrderId;
      //       }
      //     });
      //     console.log(id);
      //   if (!id) return;
      this.axios
        .post(
          `/fbxTrail/queryApptWarehouseOrderBoxs`,
          qs.stringify({
            orderNo: this.orderNo,
            apptWarehouseOrderId: "18955654000",
          })
        )
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.datas.length) {
              this.boxInfo = res.data.datas;
              //   this.showDialog = true
              //   this.showBox = true;
            } else {
              this.$message("没有相关箱号");
            }
          } else {
            this.$message("获取失败");
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getPics(id) {
      this.axios
        .post(`/fbxTrail/findApptWarehouseOrderReceipt/${id}`, {})
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.datas.length) {
              this.urls = res.data.datas;
              this.showDialog = true;
              this.showPic = true;
            } else {
              this.$message("没有相关回执");
            }
          } else {
            this.$message("获取失败");
          }
          this.loading = false;
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    handleClick(tab, event) {
      //tabs的点击方法
      // console.log(tab.paneName);
      if (tab.paneName === "third") {
        this.axios
          .get("/fbxTrail/findOrderTrailByOrderNo/" + this.routes.nos, {
            headers: { language: "CN" },
          })
          .then((response) => {
            if (response.data.code == 200) {
              if (response.data.datas.length) {
                this.activitieList = response.data.datas;
              } else {
                this.$message("没有相关轨迹");
              }
            } else {
              this.$message("获取失败");
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    preViewPic(url) {
      uni.previewImage({
        urls: [url],
      });
    },
    // jack
    getSummaries(param) {
      //合计第一列不显示合计
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1) {
          sums[index] = "";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }
      });
      return sums;
    },
    comeback() {
      //返回上一页
      this.$router.push({ name: "FBAheader" });
    },
    handleSelectionChange(val) {
      //table方法
      this.multipleSelection = val;
    },

    getalldata() {
      let data = {
        jobtype: "FBX",
        language: "CN",
        nos: this.routes.nos,
        state: this.routes.state,
      };
      // console.log(data)

      this.axios
        .post("/busFbx/getFbxJobsHistoryWebSingleList", data)
        .then((response) => {
          console.log(response.data.data);
          this.Alldata = response.data.data;
          console.log(this.Alldata);
          // this.Alldata = JSON.parse(JSON.stringify(this.Alldata))
          this.tableData_C1 = response.data.data.cargobefore;
          this.tableData_C2 = response.data.data.cargo;
          this.tableData1 =
            response.data.data.combincostinfo.combinCostinfoList; //数据列表
          this.twotableData = [
            {
              feeitem: "合计",
              amountBefore: response.data.data.combincostinfo.totalCostBefore,
              amount: response.data.data.combincostinfo.totalCost,
            },
            {
              feeitem: "折合人民币",
              amountBefore: response.data.data.combincostinfo.amountBefore,
              amount: response.data.data.combincostinfo.amount,
            },
          ];
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    CargoTrackByNo() {},
  },
  created() {
    this.routes = this.$route.query;
    this.state = this.routes.state;
    this.CargoTrackByNo();
    this.getalldata();
  },
  mounted() {},
};
</script>

<style lang="less" >
.jackTextAc {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}
.jackText {
  font-size: 18px;
  font-weight: bold;
  color: #999;
}
.jackContent {
  padding: 10px;
  .el-timeline-item__content {
    width: 500px;
  }
}
.jackRadius {
  /deep/.el-dialog {
    border-radius: 20px;
  }
}
.jackCard {
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  margin: 20px 0 20px 30px;
  background: #ffffff;
}
.OrderDetails {
  
  // width: 100%;
  /* background: #FBFBFB; */
  border-radius: 5px;
}
.OrderDetails .comeback {
  width: 120px;
  margin-bottom: 5px;
  font-size: 18px;
  cursor: pointer;
}
.OrderDetails .comeback:hover {
  color: #409eff;
}
.OrderDetails .comeback span:nth-child(1) {
  margin-left: 12px;
  margin-right: 5px;
  font-size: 22px;
  vertical-align: -1px;
}
.OrderDetails .divbox {
  width: 95%;
  margin: 0 auto;
  margin-bottom: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
}
.OrderDetails h4 {
  height: 18px;
  padding-top: 18px;
  margin-left: 24px;
  font-size: 18px;
  font-family: "PingFang SC";
  font-weight: bold;
  color: #343434;
}
.OrderDetails .RequestInfo {
  /* height: 215px; */
  margin-top: 22px;
  /* padding-bottom: 20px; */
}
.OrderDetails .Blurb {
  width: 95%;
  /* height: 242px; */
  margin: 0 auto;
  margin-bottom: 20px;
  display: flex;
}
.OrderDetails .Information {
  /* height: 283px; */
  padding-bottom: 22px;
}
.OrderDetails .Blurb .tablebox {
  width: 49%;
  background: #ffffff;
  padding-bottom: 20px !important;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
}
.OrderDetails .Blurb .tablebox:nth-child(1) {
  margin-right: 2%;
}
.OrderDetails .divbox .RI_ul {
  display: flex;
}
.OrderDetails .divbox .RI_ul li {
  width: 31%;
  margin-left: 24px;
  margin-top: 20px;
}
.OrderDetails .divbox .RI_ul li:nth-child(1) {
  margin-left: 0;
}
.OrderDetails .divbox .RI_ul li:nth-child(2) {
  margin-left: 1%;
  margin-right: 1%;
}
.OrderDetails .divbox .RI_ul li p {
  margin-bottom: 19px;
  font-size: 14px;
  /* mar- */
}
.OrderDetails .divbox .RI_ul li p span {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
}
.OrderDetails .divbox .RI_ul li p span:nth-child(1) {
  width: 90px;
  margin-right: 27px;
  color: #9a9a9a;
  text-align: right;
}
.OrderDetails .divbox .RI_ul li p span:nth-child(2) {
  width: 200px;
  height: 16px;
  color: #343434 !important;
  text-align: left;
}
.OrderDetails .Information .RI_ul li {
  margin-top: 0px;
}
/* element */
.OrderDetails .endtwotr {
  margin-top: -2px;
}
.OrderDetails .Information .el-timeline-item {
  padding-bottom: 30px;
}
.OrderDetails .Blurb .el-table td,
.el-table th {
  padding: 8px 0;
}
.OrderDetails .Information .el-table td,
.el-table th {
  padding: 7px 0;
}
.OrderDetails .el-tabs__item {
  font-size: 16px;
}
.OrderDetails .el-timeline-item__tail {
  position: absolute;
  left: 155px;
  top: 7px;
}
.OrderDetails .el-timeline-item__node--normal {
  left: 150px;
}
.OrderDetails .el-timeline-item__wrapper {
  width: 260px;
  padding-left: 175px;
  font-size: 14px;
  font-family: "PingFang SC";
  font-weight: 500;
  color: #333333;
}
.OrderDetails .el-timeline-item__timestamp.is-bottom {
  position: absolute;
  right: 295px;
  top: 3px;
  margin-top: 0;
  color: #999999;
  font-size: 11px;
}
.OrderDetails .el-tabs__nav-wrap::after {
  background: none;
}
.OrderDetails .el-table td,
.el-table th {
  text-align: center;
}
.OrderDetails .Blurb .el-table__header tr,
.OrderDetails .Blurb .el-table__header th {
  padding: 0;
  height: 38px;
  line-height: 38px;
}
.OrderDetails .Information .el-table__header tr,
.OrderDetails .Information .el-table__header th {
  padding: 0;
  height: 31px;
  line-height: 31px;
}
.OrderDetails .el-tabs__header {
  margin-left: 21px;
  padding-top: 5px;
  margin-bottom: 25px;
  font-size: 18px;
}
/* table 滚动条 */
.OrderDetails .el-table__body-wrapper::-webkit-scrollbar {
  width: 3px;
}
.OrderDetails .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #409eff;
}
.OrderDetails .el-table__body-wrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #eee;
}
</style>


// WEBPACK FOOTER //
// src/components/PersonalCenter/FBAheader/FbaOrderDetails.vue